import { YachtDetails } from "@/src/app/Yachts/model";
import { Separator } from "@/src/components/ui/separator";

export type SpecificationProps = {
  yacht: YachtDetails;
};
export function Specification({ yacht }: SpecificationProps) {
  return (
    <>
      <div className="flex flex-col gap-4">
        <h4 className="text-xl font-semibold">Available charter types</h4>
        <span className="capitalize text-base font-medium">{yacht.type}</span>
      </div>
      <Separator />
      <div>
        <h4 className="text-xl font-semibold mb-4">Specifications</h4>
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col text-base">
            <span>Length overall</span>
            <span className="font-medium">{yacht.length}</span>
          </div>
          <div className="flex flex-col text-base">
            <span>Year</span>
            <span className="font-medium">{yacht.year}</span>
          </div>
          <div className="flex flex-col text-base">
            <span>Beam</span>
            <span className="font-medium">Beam</span>
          </div>
          <div className="flex flex-col text-base">
            <span>No. of cabins</span>
            <span className="font-medium">{yacht.cabins}</span>
          </div>
          <div className="flex flex-col text-base">
            <span>No. of berths</span>
            <span className="font-medium">No. of berths</span>
          </div>
          <div className="flex flex-col text-base">
            <span>No. of bathrooms</span>
            <span className="font-medium">{yacht.bathrooms}</span>
          </div>
          <div className="flex flex-col text-base">
            <span>No. of heads</span>
            <span className="font-medium">No. of heads</span>
          </div>
          <div className="flex flex-col text-base">
            <span>Manufacturer</span>
            <span className="font-medium">{yacht.builder}</span>
          </div>
          <div className="flex flex-col text-base">
            <span>Mainsail</span>
            <span className="font-medium">Mainsail</span>
          </div>
        </div>
      </div>
    </>
  );
}
